const apiPath = "/customs/customs-container";
const path = "CustomsContainersModule";

const CustomsContainersAPIsConstants = {
  API_PATH: `${apiPath}`,
};

const CustomsContainersActions = {
  ADD_ITEM: `${path}/addItem`,
  UPDATE_ITEM: `${path}/updateItem`,
  EDIT_ITEM: `${path}/editItem`,
  FIND_ITEM_BY_ID: `${path}/findItemById`,
  GET_INIT_DATA : `${path}/getInitData`,
};

export { CustomsContainersAPIsConstants, CustomsContainersActions };
